import React, { FunctionComponent } from 'react';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './StageStateIcon.scss';
import { StageState } from 'enums';

interface IStageStateIconProps {
    className?: string
    state: StageState,
}

const stateClasses = {
    [StageState.Scheduled]: 'scheduled',
    [StageState.Running]: 'running',
    [StageState.Canceled]: 'canceled',
    [StageState.Error]: 'error',
    [StageState.Done]: 'done',
}

export const StageStateIcon: FunctionComponent<IStageStateIconProps> = function StageStateIcon(props) {
    const { className, state } = props;

    const iconClass = cn('stageStateIcon', className, stateClasses[state]);

    const icons = {
        [StageState.Scheduled]: (
            <FontAwesomeIcon icon={['far', 'calendar-check']} className={iconClass} />
        ),
        [StageState.Running]: (
            <FontAwesomeIcon icon="download" className={iconClass} />
        ),
        [StageState.Canceled]: (
            <FontAwesomeIcon icon="ban" className={iconClass} />
        ),
        [StageState.Error]: (
            <FontAwesomeIcon icon="exclamation-triangle" className={iconClass} />
        ),
        [StageState.Done]: (
            <FontAwesomeIcon icon="check" className={iconClass} />
        ),
    }

    return icons[state] || null;
};